// PAQUETES
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useOutletContext, useParams } from "react-router-dom";
// funciones
import { slugify } from "../../funcionesDatos/Textos";
// componentes
import HelmetSEO from '../../componentesEspeciales/helmetSEO';
import PanelBusquedaServicios from '../../componentesEspeciales/busqueda/panelBusquedaServicios';
import useBusquedaServicios from '../../componentesEspeciales/busqueda/useBusquedaServicios';

// Landing page fija por categoría (ej. /categoria/belleza), pensada para pautar en
// Facebook/Google Ads: a diferencia de /busqueda, esta sí tiene una URL única y estable
// por categoría. Reutiliza el mismo motor de búsqueda que Busqueda.jsx.
function Categorias() {
  const navigate = useNavigate();
  const { categoria: categoriaSlug } = useParams();
  const { usuario, cargandoUsuario } = useOutletContext() || {};

  const [categoriaResuelta, setCategoriaResuelta] = useState(null);

  // categoriaFija le indica al hook cuál es la categoría "de base" de esta página:
  // así, al Limpiar filtros o reiniciar la búsqueda, la categoría no se pierde.
  const busqueda = useBusquedaServicios({
    categoriaFija: categoriaResuelta?.categoria || null,
    idUsuario: usuario?.idUsuario || null,
  });
  const { categoriasConfig, categoria, setCategoria, setPage, ejecutarBusqueda } = busqueda;

  const [resolviendoCategoria, setResolviendoCategoria] = useState(true);
  const categoriaAplicadaRef = useRef(false);

  // Resolver el slug de la URL contra categoriasConfig (categoria real, con tildes/mayúsculas)
  useEffect(() => {
    let activo = true;

    (async () => {
      if (!Array.isArray(categoriasConfig) || categoriasConfig.length === 0) return;

      let encontrada = null;
      for (const c of categoriasConfig) {
        const slug = await slugify(c?.categoria || "");
        if (slug === categoriaSlug) { encontrada = c; break; }
      }

      if (!activo) return;
      setCategoriaResuelta(encontrada);
      setResolviendoCategoria(false);

      if (encontrada && !categoriaAplicadaRef.current) {
        categoriaAplicadaRef.current = true;
        setCategoria(encontrada.categoria);
      }
    })();

    return () => { activo = false; };
  }, [categoriasConfig, categoriaSlug, setCategoria]);

  // Primera búsqueda, una vez la categoría fija ya quedó aplicada al estado del buscador.
  useEffect(() => {
    if (cargandoUsuario) return;
    if (!categoriaAplicadaRef.current) return;
    if (categoria !== categoriaResuelta?.categoria) return;

    setPage(1);
    ejecutarBusqueda({ pageOverride: 1 });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cargandoUsuario, categoria]);

  if (!resolviendoCategoria && !categoriaResuelta) {
    return (
      <div className="container py-5 text-center">
        <h1 className="h4 fw-bold">Categoría no encontrada</h1>
        <p className="text-muted">No encontramos la categoría "{categoriaSlug}".</p>
        <button type="button" className="btn btn-primary" onClick={() => navigate("/busqueda")}>
          Ver todos los servicios
        </button>
      </div>
    );
  }

  const nombreCategoria = categoriaResuelta?.categoria || "";

  return (
    <>
      <HelmetSEO
        titulo={nombreCategoria ? `Servicios de ${nombreCategoria} | Zervicy` : "Categorías | Zervicy"}
        descripcion={
          nombreCategoria
            ? `Encuentra los mejores proveedores de ${nombreCategoria.toLowerCase()} cerca de ti. Reserva rápido y seguro en Zervicy.`
            : "Explora categorías de servicios en Zervicy."
        }
      />

      <PanelBusquedaServicios
        busqueda={busqueda}
        usuario={usuario}
        cargandoUsuario={cargandoUsuario}
        mostrarSelectorCategoria={false}
        titulo={nombreCategoria || "Categoría"}
        subtitulo={`Explora los mejores servicios de ${nombreCategoria.toLowerCase()} disponibles cerca de ti.`}
        textoIntro={`Encuentra proveedores verificados de ${nombreCategoria.toLowerCase()}, compara precios y reserva en minutos. Pagos seguros y calificaciones reales de otros usuarios.`}
        mensajeSinResultados="Ajusta ciudad, precio o subcategoría para ver más resultados."
        imagenesHero={categoriaResuelta?.imagen ? [categoriaResuelta.imagen] : undefined}
        icono={categoriaResuelta?.icono}
        mostrarBarraConfianza
        mostrarChipsSubcategoria
        mostrarBotonCercaDeMi
      />
    </>
  );
}

export default Categorias;
